export default __webpack_public_path__ + "static/media/EV.09e50bcf.jpg";